<template>
  <div class="main">
    <div class="wrap">
      <div class="code">404</div>
      <p class="title">页面未找到</p>
      <p class="desc">抱歉，您访问的页面不存在或已被删除</p>
      <router-link to="/" class="btn">返回首页</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error'
}
</script>

<style lang="scss" scoped>
.main{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
}
.wrap{
  padding: 80px 0;
  text-align: center;
}
.code{
  font-family: 'gaoel', sans-serif;
  font-weight: bold;
  font-size: 160px;
  line-height: 1;
  color: #ff0000;
  text-shadow: 0 0 20px rgba(#ff0000, .3);
}
.title{
  margin-top: 20px;
  font-size: 32px;
  color: $themeColorActive;
}
.desc{
  margin-top: 15px;
  font-size: 16px;
  color: $themeColor;
}
.btn{
  display: inline-block;
  margin-top: 40px;
  padding: 12px 40px;
  border: 1px solid #ff0000;
  background-color: #ff0000;
  border-radius: 4px;
  font-size: 16px;
  color: #fff;
  transition: all .3s;
  &:hover{
    transform: scale(1.05);
    box-shadow: 0 0 20px rgba(#ff0000, .5);
  }
}
@media screen and (max-width: 500px) {
  .code{
    font-size: 100px;
  }
  .title{
    font-size: 24px;
  }
  .desc{
    font-size: 14px;
  }
}
</style>
